import React from 'react';
import { Tooltip } from 'antd';
import { FaThumbsUp, FaThumbsDown, FaMinus } from 'react-icons/fa';

export const columnsDataComplex = [
  {
    title: "Question",
    dataIndex: "question",
    key: "question",
    sorter: (a, b) => a.question.localeCompare(b.question),
  },
  {
    title: "Answer",
    dataIndex: "answer",
    key: "answer",
    render: (text) => (
      <Tooltip title={text}>
        <span style={{ display: 'inline-block', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {text}
        </span>
      </Tooltip>
    ),
    sorter: (a, b) => a.answer.localeCompare(b.answer),
  },
  {
    title: "Site ID",
    dataIndex: "site_id",
    key: "site_id",
    sorter: (a, b) => a.site_id.localeCompare(b.site_id),
  },
  {
    title: "Site Name",
    dataIndex: "site_name",
    key: "site_name",
    sorter: (a, b) => a.site_name.localeCompare(b.site_name),
  },
  {
    title: "IP Address",
    dataIndex: "ip_address",
    key: "ip_address",
    sorter: (a, b) => a.ip_address.localeCompare(b.ip_address),
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    render: (rating) => {
      if (rating === 1) {
        return <FaThumbsUp color="green" />;
      }
      if (rating === -1) {
        return <FaThumbsDown color="red" />;
      }
      return <FaMinus color="gray" />;
    },
    sorter: (a, b) => a.rating - b.rating,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (text) => new Date(text).toLocaleDateString(),
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
  },
];
